"use client";

import * as React from "react";
import { Info } from "lucide-react";

export interface HomeInfoBannerV2Props {
  children: React.ReactNode;
}

export function HomeInfoBannerV2({ children }: HomeInfoBannerV2Props) {
  return (
    <div className="flex items-start gap-2 rounded-xl border border-blue-200/70 bg-blue-50/80 p-3 text-xs text-blue-800 dark:border-blue-900/70 dark:bg-blue-950/50 dark:text-blue-200">
      <Info className="mt-0.5 h-4 w-4 shrink-0" />
      <div>{children}</div>
    </div>
  );
}
